import React from 'react';
import { hydrateRoot } from 'react-dom/client';

import Footer from './components/footer/Footer';

export default function renderFooter() {
  const footerElement = document.getElementById('react-footer');

  if (!footerElement) { return; }

  const script = footerElement.parentElement.querySelector('script[data-dom-id="react-footer"]');

  if (!script) { return; }

  const props = JSON.parse(script.textContent);

  const { items } = props;

  hydrateRoot(
    footerElement,
    <Footer items={items} />,
  );
}
